import React, { useEffect, useState, useRef } from "react";
import api from "../../Services/api";
import { useParams, useNavigate } from "react-router-dom";
import { usePentagovContext } from "../../context/pentagovContext";
import { useAuthContext } from "../../context/authContext";
import { useOperador } from "../../Hooks/useOperador";
import MenuLateral from "../../Componentes/MenuLateral";
import MenuSuperior from "../../Componentes/MenuSuperior";
import { Form, Container, Row, Col, Card, Button } from "react-bootstrap";
import { FaPlus} from "react-icons/fa";
import iconPenta from "../../Imagens/icone_pentagrama.png";
import "./index.css";
import pdfMake from "pdfmake/build/pdfmake.min";
import pdfFonts from "pdfmake/build/vfs_fonts";



const Patrimonio = () => {
  const { IDCliente } = useParams();
  const navigate = useNavigate();
  const { objClienteAberto } = usePentagovContext();
  const { authReady } = useAuthContext();
  const { IDOperador, nome, operador, permissaoPrincipal } = useOperador();

  const [item, setItens] = useState({});
  const [clienteLogado, setClienteLogado] = useState();

  const [tipoSelecionada, setTipoSelecionada] = useState("todas");
  const [gerandoPDF, setGerandoPDF] = useState(false);
  const [itensPorTipo, setItensPorTipo] = useState({});
  const [secretariaSelecionada, setSecretariaSelecionada] = useState("todas");
  const [situacaoSelecionada, setSituacaoSelecionada] = useState("");
  const pdfRef = useRef(null);

  useEffect(() => {
    if (operador && authReady) {
      inicializaTela();
    } else {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    if (objClienteAberto?.nome && objClienteAberto?.cnpj) {
      setClienteLogado(`${objClienteAberto.nome} - CNPJ: ${objClienteAberto.cnpj}`);
      console.log(permissaoPrincipal);
    }
  }, [objClienteAberto]);

  async function inicializaTela() {
    try {
      const response = await api.get(`/patrimonio/${IDCliente}`);
      const itens = response.data.Patrimonio || [];

      // Agrupar por tipo
      const agrupados = itens.reduce((acc, curr) => {
        const tipo = curr.tipo || "Outros";
        if (!acc[tipo]) acc[tipo] = [];
        acc[tipo].push(curr);
        return acc;
      }, {});

      setItens(agrupados);
    } catch (error) {
      console.error("Erro ao buscar patrimônio:", error);
    }
  }


  const gerarPDF = () => {
    if (!pdfRef.current) return;

    setGerandoPDF(true);

    const linhas = [];

    // Logo e cabeçalho
    linhas.push({
      image: iconPenta, // precisa ser base64 ou URL pública
      width: 70,
      alignment: "center",
      margin: [0, 0, 0, 10],
    });

    linhas.push({
      text: "Pentagrama Auditoria e Consultoria Técnica Ltda",
      alignment: "center",
      color: "#555",
      fontSize: 11,
      margin: [0, 0, 0, 0],
    });

    linhas.push({
      text: "CNPJ nº 27.057.007/0001-04",
      alignment: "center",
      color: "#555",
      fontSize: 11,
      margin: [0, 0, 0, 10],
    });

    linhas.push({
      text: "Auditoria Patrimonial",
      alignment: "center",
      fontSize: 16,
      margin: [0, 0, 0, 5],
    });

    linhas.push({
      text: clienteLogado || "",
      alignment: "center",
      fontSize: 13,
      margin: [0, 0, 0, 15],
    });

    // Quantitativo e somas
    linhas.push(
      {
        canvas: [
          { type: "line", x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 0.5, lineColor: "#ccc" },
        ],
        margin: [0, 5, 0, 5],
      },
      {
      columns: [
        { text: `Qtd. de itens: ${quantidadeItens}`, alignment: "left", fontSize: 10 },
        { text: `Valor Aquisição: ${formatarBRL(somaValorAquisição)}`, alignment: "left", fontSize: 10 },
        { text: `Valor Atual: ${formatarBRL(somaValorAtual)}`, alignment: "left", fontSize: 10 },
      ],
      margin: [0, 0, 0, 15],
    },
    {
      canvas: [
        { type: "line", x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 0.5, lineColor: "#ccc" },
      ],
      margin: [0, 5, 0, 5],
    }
  );

    // Itens por tipo
    Object.keys(item)
      .filter((categoria) => tipoSelecionada === "todas" ? true : categoria === tipoSelecionada)
      .forEach((tipo) => {
        const filtrados = item[tipo].filter(
          (pat) =>
            (secretariaSelecionada === "todas" ? true : pat.secretaria === secretariaSelecionada) &&
            (situacaoSelecionada === "" ? true : pat.situacao?.toLowerCase().includes(situacaoSelecionada.toLowerCase()))
        );

        if (filtrados.length > 0) {
          // Título do tipo com fundo cinza
          linhas.push({
            text: tipo,
            fillColor: "#f0f0f0",
            margin: [0, 5, 0, 10],
            fontSize: 14,
            alignment: "center",
          });

          filtrados.forEach((pat) => {
            linhas.push({
              stack: [
                { text: `Descrição: ${pat.descricao}`, margin: [0, 0, 0, 2] },
                { text: `Tipo: ${pat.tipo || "-"}`, margin: [0, 0, 0, 2] },
                { text: `Secretaria/Departamento: ${pat.secretaria || "-"}`, margin: [0, 0, 0, 2] },
                { text: `Valor Aquisição: ${formatarBRL(pat.valoraquisicao) || "-"}`, margin: [0, 0, 0, 2] },
                { text: `Valor Atual: ${formatarBRL(pat.valoratual) || "-"}`, margin: [0, 0, 0, 2] },
                { text: `Situação: ${pat.situacao || "-"}`, margin: [0, 0, 0, 2] },
                { text: `Observação: ${pat.observacao || "-"}`, margin: [0, 0, 0, 5] },
                {
                  canvas: [
                    { type: "line", x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 0.5, lineColor: "#ccc" },
                  ],
                  margin: [0, 5, 0, 5],
                }
              ],
              margin: [0, 0, 0, 5],
              border: [true, true, true, true],
              fillColor: "#ffffff",
              lineWidth: 0.5,
              lineColor: "#ccc",
              padding: [5, 5, 5, 5],
            });
          });
        }
      });

    const docDef = {
      content: linhas,
      defaultStyle: {
        fontSize: 10,
        color: "#333",
      },
    };

    pdfMake.createPdf(docDef).download(`AuditoriaPatrimonial_${IDCliente}.pdf`);
    setGerandoPDF(false);
  };



  const itensFiltrados = Object.keys(item)
  .filter((categoria) =>
    tipoSelecionada === "todas" ? true : categoria === tipoSelecionada
  )
  .flatMap((tipo) =>
    item[tipo].filter((pat) =>
      secretariaSelecionada === "todas" ? true : pat.secretaria === secretariaSelecionada
    )
  );

  const quantidadeItens = itensFiltrados.length;

  const somaValorAtual = itensFiltrados.reduce((acc, pat) => {
    const valor = parseFloat(pat.valoratual?.toString().replace(",", ".") || 0);
    return acc + valor;
  }, 0);

  const somaValorAquisição = itensFiltrados.reduce((acc, pat) => {
    const valor = parseFloat(pat.valoraquisicao?.toString().replace(",", ".") || 0);
    return acc + valor;
  }, 0);

  const formatarBRL = (valor) => {
    return Number(valor).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  };

  return (
    <div className="menu-container-menu">
      <MenuLateral />
      <div id="painel_principal_menu" align="center">
        <MenuSuperior
          userId={String(IDOperador).padStart(6, "0")}
          userName={nome}
          cliente={clienteLogado}
        />

        <br />
        <h3>Auditoria Patrimonial</h3>
        {(permissaoPrincipal === 99 || permissaoPrincipal === 90) && (
          <div>
            <Button
              variant="success"
              onClick={() => navigate('/CadPatrimonio/' + IDCliente)}
            >
              <FaPlus /> Adicionar / Editar / Deletar
            </Button>
          </div>
        )}

        <Container className={`PerguntasPlanejamento mt-4 ${gerandoPDF ? "pdf-mode" : ""}`}>
          <Row className="mb-8 no-print">
            <Col md={6} className="text-start">
              <br />
              <Form.Label>
                <strong>Filtrar por Tipo:</strong>
              </Form.Label>
              <Form.Select
                value={tipoSelecionada}
                onChange={(e) => setTipoSelecionada(e.target.value)}
              >
                <option value="todas">Todos os Tipos</option>
                {Object.keys(item).map((tipo, idx) => (
                  <option key={idx} value={tipo}>
                    {tipo}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col md={6} className="text-start">
              <br />
              <Form.Label>
                <strong>Filtrar por Secretaria:</strong>
              </Form.Label>
              <Form.Select
                value={secretariaSelecionada}
                onChange={(e) => setSecretariaSelecionada(e.target.value)}
              >
                <option value="todas">Todas as Secretarias</option>
                {Object.values(item) // pega todos os arrays por tipo
                  .flat()
                  .map((pat) => pat.secretaria)
                  .filter((value, index, self) => value && self.indexOf(value) === index) // remove duplicados e null
                  .map((sec, idx) => (
                    <option key={idx} value={sec}>
                      {sec}
                    </option>
                  ))}
              </Form.Select>
            </Col>
            <Col md={6} className="text-start">
              <br />
              <Form.Label>
                <strong>Filtrar por Situação:</strong>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Digite parte da situação"
                value={situacaoSelecionada}
                onChange={(e) => setSituacaoSelecionada(e.target.value)}
              />
            </Col>

            <Col md={6} className="text-end">
              <br/> 
              <div className="mb-12" style={{ marginLeft: "30px", marginInlineEnd:'15%' }}>
                <br />
                <button 
                  className="btn btn-outline-dark" 
                  onClick={gerarPDF} 
                  disabled={gerandoPDF}
                >
                  {gerandoPDF ? "Gerando PDF..." : "Gerar PDF"}
                </button>
              </div>
            </Col>

            <Row className="mb-3" style={{paddingTop:'20px'}}>
              <Col md={2}>
                <strong>Quantidade:</strong> {quantidadeItens}
              </Col>
              
              <Col md={5}>
                <strong>Soma Valor Aquisição:</strong> {somaValorAquisição.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })}
              </Col>

              <Col md={5}>
                <strong>Soma Valor Atual:</strong> {somaValorAtual.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })}
              </Col>
              
            </Row>
          </Row>

          {Object.keys(item)
            .filter((categoria) =>
              tipoSelecionada === "todas" ? true : categoria === tipoSelecionada
            )
            .map((tipo, idx) => (
              <div key={idx} className="mb-5">
                <br />
                <h4 className="mb-3 border-bottom pb-2">{tipo}</h4>

                {item[tipo]
                  .filter((pat) =>
                    (secretariaSelecionada === "todas" ? true : pat.secretaria === secretariaSelecionada) &&
                    (situacaoSelecionada === "" ? true : pat.situacao?.toLowerCase().includes(situacaoSelecionada.toLowerCase()))
                  )
                  .map((pat) => (
                    <Card className="mb-3 shadow-sm" key={pat.IDPlanejamento_perguntas}>
                      <Card.Body>
                        <Row>
                          <Col md={12}>
                            <Card.Title className="mb-2" style={{ fontWeight: "600", textAlign: "left" }}>
                              {pat.descricao}
                            </Card.Title>
                          </Col>
                        </Row>
                        <Row className="mb-2" style={{ textAlign: "left", fontSize: "14px" }}>
                          <Col md={6}>
                            <strong>Tipo:</strong> {pat.tipo}
                          </Col>
                          <Col md={6}>
                            <strong>Secretaria/Departamento:</strong> {pat.secretaria}
                          </Col>
                        </Row>
                        <Row className="mb-2" style={{ textAlign: "left", fontSize: "14px" }}>
                          <Col md={6}>
                            <strong>Valor Aquisição:</strong> {formatarBRL(pat.valoraquisicao)}
                          </Col>
                          <Col md={6}>
                            <strong>Valor Atual:</strong> {formatarBRL(pat.valoratual)}
                          </Col>
                        </Row>
                        <Row className="mb-2" style={{ textAlign: "left", fontSize: "14px" }}>
                          <Col md={6}>
                            <strong>Situação:</strong> {pat.situacao}
                          </Col>
                        </Row>
                        <Row style={{ textAlign: "left", fontSize: "14px" }}>
                          <Col md={12}>
                            <strong>Observação:</strong> {pat.observacao}
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  ))}
              </div>
          ))}

          <br />
        </Container>
      </div>


      {/* PDF escondido */}
      <div style={{display: "none"}}>
        <div
          id="conteudo-pdf"
          ref={pdfRef}
          style={{ fontFamily: "Arial, sans-serif", padding: "20px", fontSize: "12px", color: "#333" }}
        >
          <div style={{ textAlign: "center", marginBottom: "30px" }}>
            <img src={iconPenta} alt="Logo" style={{ height: "70px", marginBottom: "10px" }} />
            <p style={{ fontSize: "11px", color: "#555", margin: 0 }}>
              Pentagrama Auditoria e Consultoria Técnica Ltda
            </p>
            <p style={{ fontSize: "11px", color: "#555", margin: 0 }}>CNPJ nº 27.057.007/0001-04</p>
            <h4 style={{ marginTop: "15px", fontSize: "16px", fontWeight: "normal" }}>Auditoria Patrimonial</h4>
            <p style={{ fontSize: "13px" }}>{clienteLogado}</p>
          </div>

          {/* Quantitativo e soma do valor atual */}
            <p style={{ fontSize: "12px", marginBottom: "15px", textAlign: "right" }}>
              <strong>Quantidade de itens:</strong> {quantidadeItens} &nbsp; | &nbsp;
              <strong>Soma Valor Aquisição:</strong> {formatarBRL(somaValorAquisição)} &nbsp; | &nbsp;
              <strong>Soma Valor Atualizado:</strong> {formatarBRL(somaValorAtual)}
            </p>

          {Object.keys(item)
            .filter((categoria) =>
              tipoSelecionada === "todas" ? true : categoria === tipoSelecionada
            )
            .map((tipo, idx) => (
              <div key={idx} style={{ marginBottom: "35px" }}>
                <h5
                  style={{
                    textAlign: "center",
                    backgroundColor: "#f0f0f0",
                    padding: "8px 12px",
                    fontSize: "14px",
                    marginBottom: "20px",
                    borderRadius: "4px",
                    fontWeight: "normal",
                  }}
                >
                  {tipo}
                </h5>

                {item[tipo]?.map((pat, i) => (
                  <div
                    key={i}
                    style={{
                      padding: "10px 15px",
                      marginBottom: "15px",
                      borderBottom: "1px solid #ccc",
                    }}
                  >                   
                    <p><strong>Descrição:</strong> {pat.descricao}</p>
                    <p><strong>Tipo:</strong> {pat.tipo || "-"}</p>
                    <p><strong>Secretaria/Departamento:</strong> {pat.secretaria || "-"}</p>
                    <p><strong>Valor aquisição:</strong> {formatarBRL(pat.valoraquisicao) || "-"}</p>
                    <p><strong>Valor atual:</strong> {formatarBRL(pat.valoratual) || "-"}</p>
                    <p><strong>Situação:</strong> {pat.situacao || "-"}</p>
                    <p><strong>Observação:</strong> {pat.observacao || "-"}</p>
                  </div>
                ))}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default Patrimonio;